var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Report, ReportingEndpoint } from "../../services/reporting";
import promisify from "../../utils/promisify";
import { Cart } from "../../services/cart";
export const DELAYED_REPORT_LS_KEY = "fs-delayed-report";
export function getDelay(timeout) {
    const time = Date.now() - window.performance.timeOrigin;
    if (timeout > time) {
        return timeout - time;
    }
    return 0;
}
export function DelayedReport(_a) {
    var { endpoint = ReportingEndpoint.General, params, upType, prefix, globalHookName, timeout } = _a, base = __rest(_a, ["endpoint", "params", "upType", "prefix", "globalHookName", "timeout"]);
    const report = Object.assign(Object.assign({}, base), { params: params, upType,
        endpoint,
        globalHookName,
        timeout });
    localStorage.setItem(getDelayedKey(prefix), JSON.stringify(report));
    return promisify(() => true);
}
export function executeDelayedReport(prefix) {
    const key = getDelayedKey(prefix);
    if (key in localStorage) {
        const _a = JSON.parse(localStorage.getItem(key)), { params, upType, globalHookName, timeout = 5000, endpoint } = _a, base = __rest(_a, ["params", "upType", "globalHookName", "timeout", "endpoint"]);
        localStorage.removeItem(key);
        const delay = getDelay(timeout);
        function report() {
            var _a, _b;
            Report(Object.assign(Object.assign({}, base), { cartToken: (_b = (_a = Cart.getToken(base.platform)) !== null && _a !== void 0 ? _a : base.cartToken) !== null && _b !== void 0 ? _b : "", endpoint, params: params, upType, userSession: (params === null || params === void 0 ? void 0 : params.st) ? params === null || params === void 0 ? void 0 : params.st : base === null || base === void 0 ? void 0 : base.userSession })).then(() => {
                if (globalHookName) {
                    window[globalHookName]();
                }
            });
        }
        if (delay) {
            setTimeout(report, delay);
        }
        else {
            report();
        }
    }
}
export function deleteDelayedReport(prefix) {
    const key = getDelayedKey(prefix);
    if (key in localStorage) {
        localStorage.removeItem(key);
    }
}
export const getDelayedKey = (prefix) => `${prefix}-${DELAYED_REPORT_LS_KEY}`;
export const productPossibleKey = `product-${DELAYED_REPORT_LS_KEY}`;
//# sourceMappingURL=delayedReport.js.map